export { default } from './Swipeable';
